import React from "react";
import { SvgIcon } from "@mui/material";
import PropTypes from "prop-types";

const RepositoryItemIcon = ({ color }) => {
  return (
    <SvgIcon color={color}>
      <path d="M18 13H17.32L17.23 15L19 17H5L6.78 15L6.83 13H6L3 16V20C3 21.1 3.89 22 4.99 22H19C20.1 22 21 21.11 21 20V16L18 13Z" />
      <path d="M13.125 2H8.625C8.00625 2 7.50563 2.54 7.50563 3.2L7.5 12.8C7.5 13.46 8.00062 14 8.61937 14H15.375C15.9937 14 16.5 13.46 16.5 12.8V5.6L13.125 2ZM14.25 11.6H9.75V10.4H14.25V11.6ZM14.25 9.2H9.75V8H14.25V9.2ZM12.5625 6.2V2.9L15.6562 6.2H12.5625Z" />
    </SvgIcon>
  );
};

export default RepositoryItemIcon;

RepositoryItemIcon.propTypes = {
  color: PropTypes.string
};

RepositoryItemIcon.defaultProps = {
  color: "inherit"
};
